import {
  FORMAT_TEXT_COMMAND
} from "lexical";


export const handleClick = ({ editor, format }) => {
  editor.dispatchCommand(FORMAT_TEXT_COMMAND, format);
};
